import {createAsyncThunk} from '@reduxjs/toolkit';
import {itemsApi} from 'api';
import {ICreateItemPayload, IQuestionBase} from 'models';
import {pages} from 'paths';
import {toastNotificationManager} from 'toast-notifications';
import {itemsMessages} from '../../utils';
import {prefix} from './config';

export const createItemThunk: any = createAsyncThunk<IQuestionBase, ICreateItemPayload>(
  `${prefix} createItem`,
  async (payload: ICreateItemPayload, {dispatch, rejectWithValue}) => {
    try {
      const {parsedBody} = await itemsApi.createUpdateItem(payload);
      dispatch(toastNotificationManager.createSuccessToastAction(itemsMessages.createSuccess));
      payload.push(pages.adminPortal.items.root);
      return parsedBody;
    } catch (err) {
      dispatch(toastNotificationManager.createErrorToastAction(err.parsedBody));
      return rejectWithValue({error: err});
    }
  }
);
